module.exports = __webpack_public_path__ + "img/mob_bg_graph.32e2996e.png";